import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddMerchandise';

const AddMerchandisePage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddMerchandisePage;
